import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Grid, Header, Segment } from 'semantic-ui-react';

import { formatDetailsDisp } from '../../../app/common/util/util';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { RootStoreContext } from '../../../app/stores/rootStore';

interface DetailParams {
  id: string;
}

const DepositSalesTicketDetails: React.FC<
  RouteComponentProps<DetailParams>
> = ({ match, history }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    depositSalesTicket,
    loading,
    loadDepositSalesTicket,
  } = rootStore.depositSalesTicketStore;

  useEffect(() => {
    loadDepositSalesTicket(match.params.id);
  }, [loadDepositSalesTicket, match.params.id, history]);

  if (loading) return <LoadingComponent content='Loading...' />;

  if (!depositSalesTicket) return <h2>not found</h2>;

  return (
    <Grid>
      <Grid.Column width={10}>
        <Header as='h4' attached='top' block size='small'>
          チケットNo
        </Header>
        <Segment attached size='small'>
          {depositSalesTicket.ticketNo}
        </Segment>
        <Header as='h4' attached block size='small'>
          委託先
        </Header>
        <Segment attached size='small'>
          {depositSalesTicket.agentName}
        </Segment>
        <Header as='h4' attached block size='small'>
          作成日 / 発券日
        </Header>
        <Segment attached size='small'>
          {formatDetailsDisp(new Date(depositSalesTicket.registrationDate))}
          {depositSalesTicket.ticketReserveTime &&
            ` / ${formatDetailsDisp(
              new Date(depositSalesTicket.ticketReserveTime)
            )}`}
        </Segment>
        <Header as='h4' attached block size='small'>
          入場可能期間
        </Header>
        <Segment attached size='small'>
          {depositSalesTicket.startDate &&
            formatDetailsDisp(new Date(depositSalesTicket.startDate))}{' '}
          ～{' '}
          {depositSalesTicket.limitMonthDate &&
            formatDetailsDisp(new Date(depositSalesTicket.limitMonthDate))}
        </Segment>
        <Header as='h4' attached block size='small'>
          テナント
        </Header>
        <Segment attached size='small'>
          {depositSalesTicket.mdTdTicketTypeName}
        </Segment>
        <Header as='h4' attached block size='small'>
          券種
        </Header>
        <Segment attached size='small'>
          {depositSalesTicket.ticketDisplayName}
        </Segment>
        <Header as='h4' attached block size='small'>
          単価 / 枚数 / 金額
        </Header>
        <Segment attached size='small'>
          {depositSalesTicket.unitPrice.toLocaleString()}円 /{' '}
          {depositSalesTicket.count.toLocaleString()}枚 /{' '}
          {depositSalesTicket.cashTotal.toLocaleString()}円
        </Segment>
        <Header as='h4' attached block size='small'>
          発券ステータス
        </Header>
        <Segment attached size='small'>
          {depositSalesTicket.ticketReserveStatusName}
        </Segment>
        <Header as='h4' attached block size='small'>
          発券区分
        </Header>
        <Segment attached='bottom' size='small'>
          {depositSalesTicket.ticketReserveTypeName}
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default observer(DepositSalesTicketDetails);
